export default __webpack_public_path__ + "static/media/nails.a0a45c5a.jpg";